import React from 'react'

import DeviceStatusComponent from '../Components/DeviceStatus/DeviceStatusComponent'
import { useDeviceState } from '@context/device/context/device.context'

const DeviceStatus: React.FC = () => {
  const { devices } = useDeviceState()

  return (
    <div>
      <DeviceStatusComponent devices={devices} />
    </div>
  )
}

export default DeviceStatus
